module.exports = __webpack_public_path__ + "static/media/udcoDashboard.46acfb94.svg";